import { css } from "styled-components";
import { Carousel, CarouselSlide, CarouselViewport } from "../../../../components/Carousel";
import { BladeHeaderBody } from "../../../../components/BladeHeader";
export const riotProductSkin = (chroma, paletteTokens) => css `
  /* Adding outline var to use across the blade styles for preventing layout shift on slide focus */
  --focus-outline-size: ${chroma.spacers.constant.xxxs};

  & {
    position: relative;
    max-width: ${chroma.dimensions.pageWidth};
    width: 100%;
    margin: 0 auto;
    background-color: ${paletteTokens.bladebg1};
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  ${BladeHeaderBody} > p {
    width: 100%;
    max-width: 550px;
    ${chroma.mediaQueries.tabletDown} {
      max-width: 563px;
    }
    ${chroma.mediaQueries.mobileDown} {
      max-width: 100%;
    }
  }

  ${Carousel} {
    width: 100%;
    position: relative;

    ${CarouselViewport} {
      padding: var(--focus-outline-size) ${chroma.spacers.variable.l};

      &:focus,
      :focus-visible {
        outline: none;
      }

      align-items: center;
    }

    ${CarouselSlide} {
      align-self: flex-end;
      min-width: 90%;

      &.clickable {
        cursor: pointer;
      }

      img {
        width: 100vw;
      }
      ${chroma.mediaQueries.desktopUp} {
        &[data-focused="true"] {
          outline: var(--focus-outline-size) solid ${paletteTokens.underlay};
        }
      }
      ${chroma.mediaQueries.tabletDown} {
        min-width: 95%;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map